module.exports = __webpack_public_path__ + "img/pic_333829.935fd6bc.jpg";